import React, { useState } from 'react';
import Theme, { ThemeType } from '../theme';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, StyleSheet, Text } from 'react-native';
import { getNextStep, navigateToNextStep } from './actions';
import { SelectionContainer } from '../Bookings/components/SelectionContainer';
import { defaultScale} from '../utils/scaling';
import { genders } from '../utils';
import { SignupScreen } from 'fitbeat.gym-core';
import { GoogleAnalytics } from '../services/google-analytics';

const HomeGender = ({
  t,
  navigation,
  getNextStep,
  navigateToNextStep,
}) => {
  const [selectedGender, setSelectedGender] = useState(null);
  const setGenderAndNavigateToNextStep = (gender) => {
    const  googleAnalytics = new GoogleAnalytics();
    setSelectedGender(gender);
    getNextStep({
      currentScreen: SignupScreen.Gender,
      userProfile: { gender },
    });
    navigateToNextStep(navigation);
    googleAnalytics.logEventWithParamaters('sign_up_gender', { gender });
  };
  return (
    <View style={styles.container}>
      <Text
        style={[Theme.textStyle.heading, { marginBottom: defaultScale(6) }]}
      >
        {t('WhatIsYourGender')}
      </Text>
      <Text
        style={[
          Theme.textStyle.bodyCopyReg,
          { color: Theme.GREY_MEDIUM, marginBottom: defaultScale(24) },
        ]}
      >
        {t('personalizeFitnessJourneyGender')}
      </Text>
      {genders.map((gender) => {
        return (
          <SelectionContainer
            title={gender.display}
            style={{
              paddingHorizontal: defaultScale(33),
              marginBottom: defaultScale(10),
            }}
            isSelected={selectedGender === gender.value}
            theme={ThemeType.light}
            onPress={() => {
              setGenderAndNavigateToNextStep(gender.value);
            }}
            height={defaultScale(100)}
            width={'100%'}
            titleStyle={styles.bookingSelectionTitle}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: defaultScale(16),
    backgroundColor: Theme.WHITE ,
  },
  bookingSelectionTitle: {
    fontSize: Theme.textStyle.heading.fontSize,
    fontFamily: Theme.textStyle.heading.fontFamily,
    textAlign: 'center',
  },
});

const mapStateToProps = (state) => {
  return {
    userProfile: state.auth.signup.userProfile,
  };
};

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export const HomeGenderScreen = translate(['auth'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(HomeGender),
);
